<!-- purchase-history.component.html -->
<app-block-ui-wrapper [blockUIName]="'cart-section'" #blockUIWrapper>
<div class="main container" *ngIf="user?.loggedin && downloadOn">
  <div class="page-header">
    <h1>Purchase History</h1>
  </div>
  
  <div class="row">
    <div class="col-sm-3">
      <div class="panel panel-default">
        <div class="panel-body">
          <h4>Filter Purchase History</h4>
          <hr>
          <form>
            <div class="mb-3">
              <label>Order #</label>
              <input type="text" [(ngModel)]="filters.uuid" placeholder="Enter order #" class="form-control" name="filtersUuid"/>
            </div>
            
            <div class="mb-3">
              <label>Order Date</label>
              <div>
                <input type="text" 
                       class="form-control flatpickr" 
                       id="purchaseDate" 
                       name="purchaseDate"
                       [(ngModel)]="filters.dateRange" 
                       placeholder="{{LOCALIZATION.purchaseDatePlaceholder}}"
                       (focus)="openDatePicker('purchaseDate')" 
                       (keyup.enter)="filter()"/>
                <i class="fas fa-calendar-alt pointMe" style="float:right;margin-top:4px;" (click)="openDatePicker('purchaseDate')" title="{{LOCALIZATION.openCalendar}}"></i>
              </div>
            </div>
            
            <div class="mb-3">
              <label>Order Total</label>
              <div><span>Min</span><input type="number" step="any" style="width:50%" [(ngModel)]="filters.minAmount" placeholder="Min total" class="form-control" name="filtersMinAmount"/></div>
              <div><span>Max</span><input type="number" step="any" style="width:50%" [(ngModel)]="filters.maxAmount" placeholder="Max total" class="form-control" name="filtersMaxAmount"/></div>
            </div>
            
            <div>
              <button class="btn btn-primary" (click)="filter()">Filter</button>
              <button class="btn btn-default" (click)="clear()">Clear</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    
    <div class="col-sm-9">
      <div *ngIf="transactions.length > 0">
        <div class="row">
          <div class="col-md-4">
            <div class="btn-group" ngbDropdown>
              <button id="pagesizeButton" type="button" class="btn btn-primary btn-sm" ngbDropdownToggle [disabled]="disabled">
			      {{LOCALIZATION.showing}} <span class="badge bg-secondary">{{ pagination.elementsPerPage }}</span> per page <span class="caret"></span>
			  </button>
              <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="pagesizeButton" role="menu">
                <li ngbDropdownItem *ngFor="let size of [10, 20, 30, 50]" (click)="pageSizeChanged(size)"><a>{{size}}</a></li>
              </ul>
            </div>
          </div>
          
          <div class="col-md-4">
            <div class="btn-group" ngbDropdown>
            <button id="sortButton" type="button" class="btn btn-primary btn-sm" ngbDropdownToggle [disabled]="disabled">
			    Sorting by <span class="badge bg-secondary">{{pagination.sorting.description}}</span> <span class="caret"></span>
			</button>
            <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="sortButton" role="menu">
              <li ngbDropdownItem *ngFor="let option of sortingOptions" (click)="sortingChanged(option)">{{option.description}}</li>
            </ul>
            </div>
          </div>
          
          <div class="col-md-4">
           <button id="exportButton" type="button" class="btn btn-primary btn-sm" (click)="printTransactions(transactions)">Export Page</button>
          </div>
          <div class="col-md-12 text-right" style="margin-top:-10px">
			  <ngb-pagination 
			    [collectionSize]="totalElements"
			    [pageSize]="pagination.elementsPerPage"
			    [(page)]="pagination.page"
			    [maxSize]="5"
			    [boundaryLinks]="true"
			    (pageChange)="pageChanged()"> <!-- onPageChange($event) -->
			  </ngb-pagination>
			</div>
        </div>
        <div id="currentPage">
        <div *ngFor="let transaction of transactions; let k = index" id="transactionPanel" class="panel panel-default">
          <div class="panel-heading">
            <div class="row">
              <div class="col-xs-5"><label>ORDER #</label> {{transaction.uuid}}</div>
              <div class="col-xs-4"><label>ORDER PLACED ON</label> {{transaction.creation}}</div>
              <div class="col-xs-3"><label>TOTAL</label> {{transaction.amount | currency:'USD'}}</div>
            </div>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-xs-5">
			  <span>Status : </span>
			  <label class="label" 
			         [ngClass]="{
			           'label-success': transaction?.orderStatus?.status === OrderStatusEnum.COMPLETED,
			           'label-warning': transaction?.orderStatus?.status === OrderStatusEnum.EXPIRED,
			           'label-danger': transaction?.status === TransactionStatus.REJECTED,
			           'label-default': transaction?.status === TransactionStatus.PENDING
			         }">
			    {{ transaction?.orderStatus?.status ?? transaction?.status }}
			  </label>
			</div>

              <div class="col-xs-7">
                <div>
                <button style="margin-bottom:5px;margin-right:5px" *ngIf="transaction.orderStatus?.status == OrderStatusEnum.COMPLETED" class="btn btn-primary btn-xs" (click)="downloadOrder(transaction.uuid, false)">Download Order</button>
                <button style="margin-bottom:5px;margin-right:5px" *ngIf="transaction.orderStatus?.status == OrderStatusEnum.COMPLETED" class="btn btn-primary btn-xs" (click)="downloadOrder(transaction.uuid, true)">Download Order PDF</button>
                <button style="margin-bottom:5px" ng-show="transaction.status != ransactionStatus.PENDING && transaction.status != ransactionStatus.CANCELLED " type="button" class="btn btn-info btn-xs" title="Print friendly details" (click)="printTransaction(transaction)">Print Receipt</button>
                </div>
              </div>
            </div>
            <div class="row">
			  <table class="table table-condensed">
			    <thead>
			      <tr>
			        <th></th>
			        <th></th>
			        <th></th>
			      </tr>
			    </thead>
			    <tbody>
                <tr *ngFor="let description of transaction.description; let i = index">
			        <td style="width:40px">
			          <button (click)="expandedKeys = expandedKeys === k*1000+i ? -1 : k*1000+i" class="btn btn-primary btn-xs"><span [ngClass]="{ 'glyphicon-plus': expandedKeys !== k*1000+i, 'glyphicon-minus': expandedKeys === k*1000+i }" class="glyphicon"></span></button>
			        </td>
			        <td class="text-center">
			          <span>{{ description.title }}</span>
			          {{ description.allPages.length }} Page(s)
			          <table class="table table-condensed" *ngIf="expandedKeys === k*1000+i">			            
			          <tbody>
			              <tr class="hidden-xs" *ngFor="let page of description.allPages">
			                <td>
			                  <img class="cartThumbnail pointMe" [src]="page.thumbnail" [attr.zoom-image]="page.overview">
			                </td>
			                <td>{{ page.title }}</td>
			                <td>{{ page.amount | currency:'USD' }}</td>
			                <td>
			                  <div class="text-center">
			                    <div *ngIf="transaction?.orderStatus?.status === OrderStatusEnum.COMPLETED">
			                      <button style="margin-bottom:5px;margin-right:5px" class="btn btn-xs btn-primary" (click)="downloadPage(page.download)">Download</button>
			                      <button style="margin-bottom:5px;margin-right:5px" class="btn btn-xs btn-primary" (click)="downloadPage(page.downloadPDF)">Download as PDF</button>
			                    </div>
			                  </div>
			                </td>
			              </tr>
			              <tr class="visible-xs" *ngFor="let page of description.allPages">
			                <td>
			                  <div class="text-center">
			                    <img class="cartThumbnail pointMe" [src]="page.thumbnail">
			                  </div>
			                  <div class="text-center">{{ page.title }}</div>
			                  <div class="text-center">{{ page.amount | currency:'USD' }}</div>
			                  <div class="text-center">
			                    <div *ngIf="transaction?.orderStatus?.status === OrderStatusEnum.COMPLETED">
			                      <button style="margin-bottom:5px;margin-right:5px" class="btn btn-xs btn-primary" (click)="downloadPage(page.download)">Download</button>
			                      <button style="margin-bottom:5px;margin-right:5px" class="btn btn-xs btn-primary" (click)="downloadPage(page.downloadPDF)">Download as PDF</button>
			                    </div>
			                  </div>
			                </td>
			              </tr>
			            </tbody>
			          </table>
			        </td>
			        <td>{{ description.amount | currency:'USD' }}</td>
			      </tr>
			    </tbody>
			  </table>
			</div>
            
          </div>
        </div>
        </div>
        <div>
          <div class="text-right">
              <ngb-pagination 
			    [collectionSize]="totalElements"
			    [pageSize]="pagination.elementsPerPage"
			    [(page)]="pagination.page"
			    [maxSize]="5"
			    [boundaryLinks]="true"
			    (pageChange)="pageChanged()"> <!-- onPageChange($event) -->
			  </ngb-pagination>
           </div>
        </div>
      </div> 
      <span *ngIf="transactions.length < 1"><i>{{LOCALIZATION.resultsEmpty}}</i></span>
    </div>
  </div>
</div>
</app-block-ui-wrapper>
<div class="main container" *ngIf="!user?.loggedin || !downloadOn">
  <div class="text-center full-center">
    <h1><span class="glyphicon glyphicon-remove-sign text-red"></span></h1>
    <h3><span>{{LOCALIZATION.loginPolite}}</span></h3>
  </div>
</div>

<ng-template #printTransactionTemplate let-transaction>
<div class="print-container">
<table>
  <tr>
    <td>
      <img class="pull-left" style="height:60px;" [src]="'/app/aw-ui-angular/assets/img/cosd-seal-sm-dark.png'" />
      <h3 style="display:inline-block;margin-left:10px;">Order details</h3>
    </td>
  </tr>

  <tr>
    <td>
      <table style="border:black 4px solid;">
        <tr>
          <td><b>ORDER #:</b><br />{{ transaction.uuid }}</td>
        </tr>
        <tr>
          <td><b>ORDER PLACED ON:</b><br />{{ transaction.creation }}</td>
        </tr>
        <tr>
          <td><b>TOTAL:</b><br />{{ transaction.amount | currency }}</td>
        </tr>
        <tr>
          <td><b>PayPal ID:</b><br />{{ transaction.paypal }}</td>
        </tr>
        <tr>
          <td><b>Note:</b><br />{{ transaction.note }}</td>
        </tr>
        <tr>
          <td></td>
        </tr>
        <tr>
          <td><b>Items</b></td>
        </tr>

        <tr>
          <td>
            <table class="bordered">
              <thead>
                <tr>
                  <th>Title</th>
                  <th style="width:25%">Pages</th>
                  <th style="width:25%">Amount</th>
                </tr>
              </thead>
              <tbody *ngFor="let item of transaction.description">
                <tr>
                  <td colspan="3">{{ item.title }}</td>
                </tr>
                <tr *ngFor="let page of item.allPages">
                  <td></td>
                  <td>{{ page.title }}</td>
                  <td>{{ page.amount | currency }}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Sub Total</td>
                  <td>{{ item.amount | currency }}</td>
                </tr>
              </tbody>
            </table>
            <table>
              <tr>
                <td>
                  <h2>Total</h2>
                </td>
                <td style="width:25%"></td>
                <td style="width:25%">
                  <h2>{{ transaction.amount | currency }}</h2>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
  </div>
</ng-template>

<ng-template #printTransactionsTemplate let-transaction>
<div class="print-container">
<table>
  <tr>
    <td>
      <img class="pull-left" style="height:60px;" [src]="'/app/aw-ui-angular/assets/img/cosd-seal-sm-dark.png'" />
      <h3 style="display:inline-block;margin-left:10px;">Order details</h3>
    </td>
  </tr>

  <tr *ngFor="let transaction of transactions">
    <td>
      <table style="border:black 4px solid;">
        <tr>
          <td><b>ORDER #:</b><br />{{ transaction.uuid }}</td>
        </tr>
        <tr>
          <td><b>ORDER PLACED ON:</b><br />{{ transaction.creation }}</td>
        </tr>
        <tr>
          <td><b>TOTAL:</b><br />{{ transaction.amount | currency }}</td>
        </tr>
        <tr>
          <td><b>PayPal ID:</b><br />{{ transaction.paypal }}</td>
        </tr>
        <tr>
          <td><b>Note:</b><br />{{ transaction.note }}</td>
        </tr>
        <tr>
          <td></td>
        </tr>
        <tr>
          <td><b>Items</b></td>
        </tr>

        <tr>
          <td>
            <table class="bordered">
              <thead>
                <tr>
                  <th>Title</th>
                  <th style="width:25%">Pages</th>
                  <th style="width:25%">Amount</th>
                </tr>
              </thead>
              <tbody *ngFor="let item of transaction.description">
                <tr>
                  <td colspan="3">{{ item.title }}</td>
                </tr>
                <tr *ngFor="let page of item.allPages">
                  <td></td>
                  <td>{{ page.title }}</td>
                  <td>{{ page.amount | currency }}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Sub Total</td>
                  <td>{{ item.amount | currency }}</td>
                </tr>
              </tbody>
            </table>
            <table>
              <tr>
                <td>
                  <h2>Total</h2>
                </td>
                <td style="width:25%"></td>
                <td style="width:25%">
                  <h2>{{ transaction.amount | currency }}</h2>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
  </div>
</ng-template>